import React, { Component, } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ProductosConfiguracion_ } from '../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../config/URLDB';
class TipsProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stateLoad: false,
            infoProductos: [],
            slidesPerView: 3,
            stateImg: false,
        };
    }

    componentDidMount() {
        if (window.screen.width >= 550 && window.screen.width <= 767) {
            this.setState({
                slidesPerView: 2
            })
        } else if (window.screen.width >= 60 && window.screen.width <= 549) {
            this.setState({
                slidesPerView: 1
            })
        }
        this.cargarInfo();
    }

    cargarInfo = () => {

        AOS.init({
            duration: 2000,
            easing: 'ease-in-out-back',
            once: false,
        });

        const { idprodutra } = this.props;

        const data = {
            tran: 8,
            idprodutra: idprodutra,
            descripcion: "NA",
            manejarutaimg: 0,
            rutaimg: "NA",
            usucrea: "NA",
            feccrea: Date,
            titulo: "NA",
            orden: 0,
            iditem: 5,
            estado: 1,
            idconfigitem: 0,
        };
        ProductosConfiguracion_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        /*if (response.data[0].message != "000000") {
                            this.setState({
                                stateLoad: false,
                                stateImg: false
                            })
                        } else {*/
                            this.setState({
                                infoProductos: response.data,
                                idprodutra: response.data[0].idprodutra,
                                descripcion: response.data[0].descripcion,
                                manejarutaimg: response.data[0].manejarutaimg,
                                rutaimg: response.data[0].rutaimg,
                                usucrea: response.data[0].usucrea,
                                feccrea: response.data[0].feccrea,
                                titulo: response.data[0].titulo,
                                orden: response.data[0].orden,
                                iditem: response.data[0].iditem,
                                estado: response.data[0].estado,
                                idconfigitem: response.data[0].idconfigitem,
                                stateLoad: true,
                                stateImg: true
                            })
                        /*}*/
                    } else {
                        this.setState({
                            stateLoad: false,
                            stateImg: false
                        })
                    }
                } else {
                    this.setState({
                        stateLoad: false,
                        stateImg: false
                    })
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    render() {
        const params = {
            slidesPerView: this.state.slidesPerView,
            spaceBetween: 30,
            freeMode: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            shouldSwiperUpdate: true
        }
        let cardSlider = this.state.infoProductos.map((e, i) => {
 
            return [
                <div className="card mb-5" key={i}
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        height: '320px',
                        padding: '40px',
                        margin: '10px',
                        textAlign: 'center',
                        justifyContent: 'center',
                }}>

                <div style={{ fontSize: '28px', color: '#000', marginBottom: '15px' }}>
                    <img
                            style={{ width: '80px', height: '70px', fontSize: '14px', }}
                        className="img-fluid"
                        src={`${URLImgFront}/assets${e.rutaimg}`}
                        alt={e.rutaimg}
                />

                </div>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '10px' }}>
                    <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', width: '24px', borderRadius: '2px' }} />
                    <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', width: '12px', borderRadius: '2px' }} />
                </div>
                <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>{e.titulo}</h3>
                <p style={{ fontSize: '14px', color: '#666' }}>{e.descripcion}</p>
            </div>
            ]
        });
        return (
            <React.Fragment>
                <div className="py-5" style={{
                        width: '100%',
                        padding: '40px 0px',
                        margin: '40px auto',
                        marginBlockEnd: '20px',
                        background: 'rgb(247, 247, 247)', }}>
                    <div className="container">
                        <h2 className="fs-1 fs-sm-1 fs-md-2 fs-lg-3 fw-bold text-center text-md-start font-weight-bold" data-aos="fade-left">
                            {/*AJUSTE TITULO - RQTO AHORRO Y CDAT DIGITAL JPG NOV 2025*/}
                            Tips para sacar mayor provecho a tu{''} {this.props.idtipoprod === 1 ? 'Ahorro' : 'Crédito'} {this.props.idclasificprod === 2 ? 'Digital' : ''}
                        </h2>

                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'center' }}>
                            <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '60px' }}></div>
                            <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '30px' }}></div>
                        </div>

                        {!this.state.stateLoad && (
                            <>
                                <p className="text-center text-gray-500" data-aos="fade-left"><em>No hay Tips disponibles.</em></p>
                            </>
                        )}

                        {this.state.stateLoad ? (
                            <React.Fragment>
                                <Swiper {...params} className="mx-5">
                                    {cardSlider}
                                </Swiper>
                            </React.Fragment>
                        ) : (<React.Fragment></React.Fragment>)}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TipsProducto;